import type { ExtractPropTypes, PropType } from 'vue'

export type SliderSize = 'large' | 'default' | 'small'

// 定义标记的格式化函数类型
export type FormatTooltip = (val: number) => string | number

export const sliderProps = {
  /**
   * 绑定值，支持v-model
   */
  modelValue: {
    type: [Number, Array] as PropType<number | [number, number]>,
    default: 0
  },
  /**
   * 是否禁用
   */
  disabled: {
    type: Boolean,
    default: false
  },
  /**
   * 最小值
   */
  min: {
    type: Number,
    default: 0
  },
  /**
   * 最大值
   */
  max: {
    type: Number,
    default: 100
  },
  /**
   * 步长
   */
  step: {
    type: Number,
    default: 1
  },
  /**
   * 是否显示输入框
   */
  showInput: {
    type: Boolean,
    default: false
  },
  /**
   * 是否显示间断点
   */
  showStops: {
    type: Boolean,
    default: false
  },
  /**
   * 是否显示tooltip
   */
  showTooltip: {
    type: Boolean,
    default: true
  },
  /**
   * 格式化tooltip显示内容
   */
  formatTooltip: {
    type: Function as PropType<FormatTooltip>,
    default: undefined
  },
  /**
   * 尺寸
   */
  size: {
    type: String as PropType<SliderSize>,
    default: 'default'
  },
  /**
   * 是否竖向模式
   */
  vertical: {
    type: Boolean,
    default: false
  },
  /**
   * 竖向模式下的高度
   */
  height: {
    type: String,
    default: '200px'
  },
  /**
   * 是否为范围选择
   */
  range: {
    type: Boolean,
    default: false
  },
  /**
   * 滑块的颜色
   */
  color: {
    type: String,
    default: '#409EFF'
  }
} as const

export type SliderProps = Partial<ExtractPropTypes<typeof sliderProps>>

export const sliderEmits = {
  'update:modelValue': (value: number | [number, number]) => true,
  'change': (value: number | [number, number]) => true,
  'input': (value: number | [number, number]) => true
}

export type SliderEmits = typeof sliderEmits